import React from 'react';
import { useIntl } from '@kamernet/core/Intl';
import { PageLayout } from '@kamernet/core/PageLayout';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import styles from './FAQ.module.css';

export const FAQ = () => {
  const { T } = useIntl();

  return (
    <PageLayout.SectionContainer className={styles.root}>
      <Typography className={styles.title} variant="h2">
        {T('LBL_HOME_SUPPLY_FAQ_GENERAL_TITLE')}
      </Typography>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="body1">
            {T('LBL_HOME_SUPPLY_FAQ_1_QUESTION_ROOM_NETHERLANDS')}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography
            className={styles.details}
            dangerouslySetInnerHTML={{
              __html: T('LBL_HOME_SUPPLY_FAQ_1_ANSWER_ROOM_NETHERLANDS'),
            }}
          />
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="body1">
            {T('LBL_HOME_SUPPLY_FAQ_2_QUESTION_ROOM')}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography
            className={styles.details}
            dangerouslySetInnerHTML={{
              __html: T('LBL_HOME_SUPPLY_FAQ_2_ANSWER_ROOM'),
            }}
          />
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="body1">
            {T('LBL_HOME_SUPPLY_FAQ_3_QUESTION_HOME')}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography
            className={styles.details}
            dangerouslySetInnerHTML={{
              __html: T('LBL_HOME_SUPPLY_FAQ_3_ANSWER_ROOM'),
            }}
          />
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="body1">
            {T('LBL_HOME_SUPPLY_FAQ_4_QUESTION_ROOM')}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography
            className={styles.details}
            dangerouslySetInnerHTML={{
              __html: T('LBL_HOME_SUPPLY_FAQ_4_ANSWER_ROOM'),
            }}
          />
        </AccordionDetails>
      </Accordion>
    </PageLayout.SectionContainer>
  );
};
